export interface TreatmentAutoDeliveryJob {
    id: number;
    treatmentId: string;
    designId: number;
    status: TreatmentAutoDeliveryJobStatus;
    startInSeconds: number;
    startAfter: string | Date;
    createdDate: string | Date;
}

export enum TreatmentAutoDeliveryJobStatus {
    ready = 0,
    enqueued = 1,
    delivering = 2,
    attachmentsUploaded = 3,
    fail = 4,
    cancel = 5,
    timeout = 6,
    messageDelivered = 7,
}
